class MaintenanceService {

    constructor($uibModal, $log, $rootScope, DialogService, ConfigService, $timeout,Events,$state) {

        this.$uibModal = $uibModal;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.DialogService = DialogService;
        this.ConfigService = ConfigService;
        this.$timeout = $timeout;
        this.Events = Events;
        this.$state = $state;

        this.isInMaintenanceMode = false;
        this.dialog;
        this.checkMaintenanceFlag = true;
        this.isShowGlobalError = false;
        this.isShowRequestError = false;

        this.$rootScope.$on(this.Events.CHECK_MAINTENANCE,()=>{
            //this.$log.info("MaintenanceService: checking maintenance mode");
            this.checkMaintenance();
        });
    }

    showGlobalError(){

        this.isShowGlobalError = true;
        this.$rootScope.$emit(this.Events.SHOW_GLOBAL_ERROR);
    }

    showRequestError(){

        this.isShowRequestError = true;    
        this.$rootScope.$emit(this.Events.SHOW_REQUEST_ERROR);    
    }
    
    getMaintenanceWindowMode(){
        return this.ConfigService.get("maintenanceWindowMode",true,MaintenanceService.PAGE_MODE);
    }

    getShowGlobalError(){
        //console.log("show global error");
        return this.isShowGlobalError;
    }

    getShowRequestError(){
        //console.log("show request error");
        return this.isShowRequestError;
    }

    getIsMaintenance() {
        return this.isInMaintenanceMode;
    }

    getBlockRequests() {
        return this.isInMaintenanceMode;
    }

    setCheckMaintenanceFlag(doCheckMaintenanceFlag) {
        this.checkMaintenanceFlag = doCheckMaintenanceFlag;
        this.checkMaintenance();
    }

    enableMaintenance() {
        if (!this.isInMaintenanceMode) {
            //(ga) why is this here ? this.setCheckMaintenanceFlag(checkMaintenanceFlag);
            this.isInMaintenanceMode = true;
            
            
            if(this.getMaintenanceWindowMode() === MaintenanceService.DIALOG_MODE){
                this.dialog = this.DialogService.showDialog(require("./maintenanceDialog.tpl.html"), null, null, null, "static");

                this.dialog.result.then(()=> {
                }, ()=> {
                });
            }
            
        }
    }

    checkMaintenance() {
      var maintenance = this.ConfigService.get("maintenance", true);
      //this.$log.info("MaintenanceService: checking maintenance mode maintenance="+ maintenance + ", "+ this.checkMaintenanceFlag);
    
      if (maintenance) {
          this.checkMaintenanceFlag = true; // maintenance was overruled by config flag

          if (!this.isInMaintenanceMode) {
              this.enableMaintenance(true);
          }
      }
      else {
          // only close if flag checkMaintenance = true
          if (this.isInMaintenanceMode && this.checkMaintenanceFlag) {
            this.disableMaintenance();
          }
      }

      this.$rootScope.$emit(this.Events.MAINTENANCE_CHANGED,this.getIsMaintenance());

    }

    disableMaintenance(){
        try {
            if(this.dialog){
                this.dialog.dismiss("disable");
            }
        }catch(e){

        } finally {
            this.isInMaintenanceMode = false;
            this.$state.go(this.$state.current.name,this.$state.params,{reload : true});
        }
    }

    init() {
      this.checkMaintenance();      

      //from ConfigService over $rootScope

      /*  this.$timeout(()=> {
            this.checkMaintenance();
        }, 1000);*/
    }

}

MaintenanceService.$inject = ["$uibModal", "$log", "$rootScope", "DialogService", "ConfigService", "$timeout","Events","$state"];

MaintenanceService.PAGE_MODE = "page";
MaintenanceService.DIALOG_MODE = "dialog";

export default MaintenanceService;



// WEBPACK FOOTER //
// ./src/ui/app/services/MaintenanceService/MaintenanceService.js